import React from 'react';
import { History } from 'history';
import BaseEdit from '../base/base-edit.component'; 
import Model from './eventquiz-model';  //editable..
import QuizquestionModel from '../quizquestion/quizquestion-model';

interface IProps { 
    history: History;
    caption?: string;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowQuizquestion: QuizquestionModel;
}

export default class EventquizEdit extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowQuizquestion: QuizquestionModel.defaultValue()
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }
    
    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..
            <BaseEdit history={this.props.history} caption={this.props.caption}
                endPointFilter={Model.endPointFilter} model={Model} datarow={this.state.datarow} onLoad={this.onLoad} onError={this.onError} disableCard>              
            </BaseEdit>
        );
    }
}